export const PAYIN_METHOD_OPTIONS = [
  {
    label: 'All-in-One Pay',
    value: 'All-in-One Pay',
  },
  {
    label: 'OPay',
    value: 'NGN_OPAY',
  },
  {
    label: '银行转账',
    value: 'NGN_BANK_TRANSFER',
  },
  {
    label: 'Palm Pay',
    value: 'NGN_PALM_PAY',
  },
]

export const WITHDRAW_PENDING_STATUS_MAP = {
  1: '待处理', // 待处理
  2: '处理中', // 处理中
  3: '核实中', // 待审批
  4: '已审批 等待三方处理', // 已审批
  5: '已拒绝', // 已拒绝
  6: '失败', // 失败
  7: '成功', // 成功
  8: '已退款', // 已退款
  9: '第三方支付错误', //
}

/** 可发起退款的提款订单状态：成功、第三方支付错误 */
export const WITHDRAW_REFUNDABLE_STATUSES = [7, 9]

export function canWithdrawRefund(status) {
  return WITHDRAW_REFUNDABLE_STATUSES.includes(Number(status))
}
